import React, { Component } from "react";
import { Table, DatePicker, Form, Tabs, Button, Checkbox, message } from 'antd'
import ApplyHospital from './applyHospital'
import ConsulationHospital from './consulationHospital'
import moment from 'moment'
import { getHospitalList, getStatisticsList, getCheckedTypeList } from '@/request/api'
import StaitEcharts from './staitEchart'
import {requestErrorLog } from '@/common/util'

const { TabPane } = Tabs;
// 开始日期-结束日期
const defaultSelectDate = {
  startDate: moment().startOf("day").subtract(29, "days"),
  endDate: moment().endOf("day"),
};


class Regulators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStats: "",
      tabsKey: "全部",
      commonColumn: [
        {
          title: '日期',
          dataIndex: 'Statistics_Date',
          key: 'Statistics_Date',
          render: (val) => (
            <span>
              {val && moment(val).format("YYYY-MM-DD")}
            </span>
          ),
        },
        {
          title: '当日上传数量',
          dataIndex: 'SUBMIT_COUNT',
          key: 'SUBMIT_COUNT',
        },
        {
          title: '当日会诊数量',
          dataIndex: 'COMPLETE_COUNT',
          key: 'COMPLETE_COUNT',
        },
        {
          title: '当日退回数量',
          dataIndex: 'EXIT_COUNT',
          key: 'EXIT_COUNT',
        },
        {
          title: '会诊百分比',
          dataIndex: 'CONSULTATION_PERCENTAGE',
          key: 'CONSULTATION_PERCENTAGE',
          render: (percentage) => (
            <span>{percentage || 0}%</span>
          ),
        },
      ],
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
      checkTypeList: [],
      checkedType: [],
      selectPriceDate: '',
      offsetDays: 31536000000 * 5
    }
  }

  componentDidMount() {
    this.initHospitalList()
    this.getCheckedType()
    this.handleSubmit()
  }

  // 请求医院列表
  initHospitalList() {
    getHospitalList().then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          applyHospital: res.Result.APPLY_HOSPITAL,
          consultHospital: res.Result.CONSULATION_HOSPITAL
        })
      }else {
        requestErrorLog('', '数据统计-监管机构登录报错', 0,true)
      }
    })
  }

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (values.startTime > values.endTime) {
        message.error('开始时间不得大于结束时间')
        return;
      }
      let params = {
        Type: "RegulatorsStatistics",
        HOSPITAL_CODE: "",
        EXAM_CLASS: this.state.checkedType,
        Statistics_Type: "全部",
        hospitalDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
        PageNo: this.state.PageNo,
        PageSize: this.state.PageSize
      }
      getStatisticsList(params).then((res) => {
        if (res && res.Status === 1) {
          this.setState({
            tableList: res.Result.data.list,
            dataStats: res.Result.Sum,
            RowCount: res.Result.data.rowcount,
          });
        }else {
          requestErrorLog('', '数据统计-监管机构登录查询报错', 0,true)
        }
      })
    });
  }

  // 获取检查类型
  getCheckedType() {
    getCheckedTypeList().then(res => {
      if (res && res.Status === 1) {
        const checkedType = res.Result.dataList
        let checkTypeList = [];
        if (checkedType.length === 1 && !checkedType[0].Menu_Name) {
          checkTypeList = [];
        } else {
          checkedType.forEach(item => {
            checkTypeList.push({ label: item.CLASS_NAME, value: item.CLASS_CODE })
          })
        }
        this.setState({
          checkTypeList,
        })
      }else {
        requestErrorLog('', '数据统计-监管机构登录获取检查类型报错', 0,true)
      }
    })
  }

  changeTabsKey = (key) => {
    this.setState({
      tabsKey: key,
      PageNo: 1,
      PageSize: 10,
    })
  }

  onChangeData = (value, dateString) => {
    this.setState({
      dataTime: dateString,
    })
  }

  // 只能选择今天跟今天之前的日期
  disabledDate = (current) => {
    if (this.state.selectPriceDate) {
      let selectV = moment(this.state.selectPriceDate, 'YYYY-MM-DD').valueOf()
      return current > moment(new Date(selectV + this.state.offsetDays).getTime()) ||
        current < moment(new Date(selectV - this.state.offsetDays).getTime()) ||
        current > moment().endOf('day')
    } else {
      return current > moment().endOf('day')
    }
  }
  changeRangePicker = (e) => {
    this.setState({
      selectPriceDate: ''
    })
  }
  calendarPriceRangeChange = (date) => {
    this.setState({
      selectPriceDate: date[0]
    })
  }

  //页码改变
  onChangePage = (page, pageSize) => {
    this.setState({
      PageNo: page,
    }, () => {
      this.handleSubmit()
    })
  }
  searchListFn = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10
    }, () => {
      this.handleSubmit()
    })
  }
  handleCheckTypeValue = (checkedValues) => {
    this.setState({
      checkedType: checkedValues
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { commonColumn, tableList, dataStats, tabsKey, applyHospital, consultHospital, checkTypeList } = this.state
    return (
      <>
        <Tabs className="tabWrap eleWrap" defaultActiveKey="0" type="card" onChange={this.changeTabsKey}>
          <TabPane tab="全部" key="0">
            <Form layout="inline">
              <Form.Item label="日期选择">
                {/* {getFieldDecorator("hospitalDateTime", {
                  initialValue: [defaultSelectDate.startDate, defaultSelectDate.endDate],
                  rules: [{ required: true, message: '日期不能为空！' }]
                })(
                  <RangePicker
                    disabledDate={this.disabledDate}
                    onChange={this.changeRangePicker}
                    onCalendarChange={this.calendarPriceRangeChange}
                    allowClear
                  />
                )} */}
                {getFieldDecorator('startTime', { initialValue: defaultSelectDate.startDate })(
                  <DatePicker
                    style={{ width: 135 }}
                    allowClear={false}
                    placeholder='开始日期'
                    disabledDate={this.disabledDate}
                  />)}
                <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
                <Form.Item style={{ width: 110 }}>
                  {getFieldDecorator('endTime', { initialValue: defaultSelectDate.endDate })(
                    <DatePicker
                      style={{ width: 135 }}
                      allowClear={false}
                      placeholder='结束日期'
                      disabledDate={this.disabledDate}
                    />)}
                </Form.Item>
              </Form.Item>
              <Form.Item label="检查类型">
                {getFieldDecorator("EXAM_CLASS", { initialValue: [] })(
                  <Checkbox.Group
                    onChange={this.handleCheckTypeValue}
                    options={checkTypeList}
                  >
                  </Checkbox.Group>
                )}
              </Form.Item>
              <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.searchListFn}>查询</Button>
            </Form>
            <div className="wrap">
              <Table
                style={{ width: "65%" }}
                columns={commonColumn}
                dataSource={tableList}
                bordered
                rowKey={record => record.Statistics_Date} // 需要修改为唯一的ID！
                pagination={{
                  total: this.state.RowCount,
                  current: this.state.PageNo,
                  onChange: this.onChangePage
                }}
              />
              <div className="wrap_right">
                <div className="site-card-border-less-wrapper">
                  <p>总上传病例量：<span style={{ color: "#00A2E8" }}>{dataStats.SUBMIT_COUNT}</span></p>
                  <p>总会诊病例量：<span style={{ color: "#70CFA9" }}>{dataStats.COMPLETE_COUNT}</span></p>
                  <p>总退回病例量：<span style={{ color: "#F36971" }}>{dataStats.EXIT_COUNT}</span></p>
                  <p>会诊百分比：{dataStats.CONSULTATION_PERCENTAGE === "NaN" ? 0 : dataStats.CONSULTATION_PERCENTAGE}%</p>
                </div>
                <div style={{ width: "100%" }}>
                  <StaitEcharts dataStats={dataStats} />
                </div>
              </div>

            </div>
          </TabPane>

          <TabPane tab="申请医院" key="申请医院">
            <ApplyHospital tabsKey={tabsKey} applyHospital={applyHospital} />
          </TabPane>

          <TabPane tab="会诊医院" key="会诊医院">
            <ConsulationHospital tabsKey={tabsKey} consultHospital={consultHospital} />
          </TabPane>
        </Tabs>

      </>
    );
  }
}

export default Form.create({})(Regulators);
